/**
 * The site's two buttons, without a size: the gradient one with the
 * glow, and the outlined one on the 3:1 edge. Each use adds its height,
 * corners, padding and type size, as the artboards vary them. A press
 * sinks a pixel and springs back, the same on every button.
 */
export const GRAD_BUTTON =
    "press inline-flex shrink-0 items-center justify-center whitespace-nowrap border-0 bg-grad-btn font-bold text-brand-fg shadow-glow transition-[filter,transform] hover:saturate-[1.08] disabled:cursor-not-allowed disabled:opacity-60 max-[760px]:min-h-11";

export const OUTLINE_BUTTON =
    "press inline-flex shrink-0 items-center justify-center whitespace-nowrap border border-line-control bg-card font-semibold text-fg transition-[background-color,transform] hover:bg-hover disabled:cursor-not-allowed disabled:opacity-60 max-[760px]:min-h-11";

/** The ink button on the gradient band: the dark ground, the yellow label. */
export const INK_BUTTON =
    "press inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap border-0 bg-[#14201a] font-bold text-yellow transition-transform max-[760px]:min-h-11";
